export enum SerologyType {    
    PreOp = 1
}